import React from "react";

import { showErrorToast } from "@shared/toasts/Toasts";

import { getAccount } from "../api";

export function useAccountProfile() {
    const [profile, setProfile] = React.useState<API.Profile>();
    const [billingAddress, setBillingAddress] = React.useState<API.BillingAddress | undefined>();
    const [isLoading, setIsLoading] = React.useState(true);

    const refetch = React.useCallback(
        () =>
            getAccount()
                .then(({ data }) => {
                    setProfile(data.profile);
                    setBillingAddress(data?.billingAddress);
                })
                .catch((err) => {
                    const error = err as Error;
                    showErrorToast(error.message);
                })
                .finally(() => setIsLoading(false)),
        [],
    );

    React.useEffect(() => {
        void refetch();
    }, [refetch]);

    return {
        profile,
        billingAddress,
        isLoading,
        refetch,
    };
}
